import { useEffect } from 'react';
import {
	FormContext_Actions,
	FormContext_State,
	useFormContext,
} from './FormContext';

export function useValidateStep<
	Steps extends string,
	State extends FormContext_State<Steps>,
	Action,
>(isValid: (state: State) => boolean, step: Steps): void {
	const { state, dispatch } = useFormContext<Steps, State, Action>();
	useEffect(() => {
		// No need to valid inactive steps
		if (state.activeStep !== step) return;

		if (!state.valid && isValid(state)) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore - No one is going to override this action map
			dispatch({ type: FormContext_Actions.VALIDATE, payload: true });
		}
		if (state.valid && !isValid(state)) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore - No one is going to override this action map
			dispatch({ type: FormContext_Actions.VALIDATE, payload: false });
		}
	}, [dispatch, isValid, state, step]);
}
